import { DataBean } from "../DataBean";

export class ProjectGet extends DataBean {

    public async getProjectCatalog(idProject: any, idAccount: any, state: any, regexStr: any, date: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getProjectCatalog_Number_Number_Number_String_java.util.Date_Number_Number", [idProject, idAccount, state, regexStr, date, page, recordsPerPage]);
    }

}